import { createSelector } from 'reselect'

export const getUserTypes = createSelector(
  (state) => state && state.common && Array.isArray(state.common.userTypes) ? state.common.userTypes : [],
  (userTypes) => userTypes
)
